// src/App.js

import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { AuthClienteProvider, useAuthCliente } from './context/AuthClienteContext';
import ProtectedClienteRoute from './components/ProtectedClienteRoute';
import PortalLayout from './components/PortalLayout';

// Páginas nuevas
import LoginPage from './pages/LoginPage';
import RegistroPage from './pages/RegistroPage';

// Páginas del portal
import HomePage from './pages/HomePage';
import PublicReservasPage from './pages/PublicReservasPage';
import MisReservasPage from './pages/MisReservasPage';
import MiPerfilPage from './pages/MiPerfilPage';
import RankingPage from './pages/RankingPage';
import RetasTorneosPage from './pages/RetasTorneosPage';
import TorneosPage from './pages/TorneosPage';
import ComunidadPage from './pages/ComunidadPage';
import PanelNotificiaciones from './pages/PanelNotificaciones';

function AppContent() {
  const { currentUser, loading } = useAuthCliente();

  if (loading) {
    return null; // Evita parpadeos iniciales
  }

  return (
    <Routes>
      {/* Login y registro separados */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registro" element={<RegistroPage />} />

      {/* Layout principal del portal */}
      <Route path="/" element={<PortalLayout />}>
        {/* Rutas públicas */}
        <Route path="reservas/:companyId" element={<PublicReservasPage />} />

        {/* Rutas protegidas */}
        <Route element={<ProtectedClienteRoute />}>
          <Route path="portal/inicio" element={<HomePage />} />
          <Route path="portal/mis-reservas" element={<MisReservasPage />} />
          <Route path="portal/mi-perfil" element={<MiPerfilPage />} />
          <Route path="portal/ranking" element={<RankingPage />} />
          <Route path="portal/retas-y-torneos" element={<RetasTorneosPage />} />
          <Route path="portal/torneos" element={<TorneosPage />} />
          <Route path="portal/comunidad" element={<ComunidadPage />} />
          <Route path="portal/notificaciones" element={<PanelNotificiaciones />} />
        </Route>

        {/* Redirección en la raíz */}
        <Route index element={currentUser ? <Navigate to="/portal/inicio" replace /> : <HomePage />} />
      </Route>

      {/* Fallback para rutas no encontradas */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthClienteProvider>
        <AppContent />
      </AuthClienteProvider>
    </BrowserRouter>
  );
}
